import React from 'react';
import { useInView } from 'react-intersection-observer';

import Heading from './Heading';
import Skill from './Skill';


const SekcjaSkills = () => {

    const [ref, inView] = useInView();

    return (
        <div  id='kontener-skille' className='relative top-[40rem] mt-20'>
            <Heading numerSekcji={"03"} tytul={"SKILLS"} />
            <div ref={ref} id="srodkowy-kont-skille" className='flex justify-around flex-wrap mt-16 gap-10 scale-75 
                                                        md:scale-100 transition-all duration-150 ease-in-out'>
                <div className='flex flex-col gap-10'>
                    <Skill img={"react.svg"} time={"2 YEARS"} skillName={"REACT"} percentage={90} szer={inView ? "w-[90%]" : "w-[0%]"} />
                    <Skill img={"js.svg"} time={"3 YEARS"} skillName={"JAVASCRIPT"} percentage={75} szer={inView ? "w-[75%]" : "w-[0%]"} />
                    <Skill img={"python.svg"} time={"2 YEARS"} skillName={"Python"} percentage={65} szer={inView ? "w-[65%]" : "w-[0%]"}/>
                    <Skill img={"unity.svg"} time={"1 YEAR"} skillName={"UNITY"} percentage={50} szer={inView ? "w-[50%]" : "w-[0%]"} />
                </div>
                <div className='flex flex-col gap-10'>
                    <Skill img={"htmlCSS.svg"} time={"3 YEARS"} skillName={"HTML/CSS"} percentage={90} szer={inView ? "w-[90%]" : "w-[0%]"} />
                    <Skill img={"tailwind.svg"} time={"1 YEAR"} skillName={"TAILWIND CSS"} percentage={85} szer={inView ? "w-[85%]" : "w-[0%]"}/>
                    <Skill img={"next.svg"} time={"1 YEAR"} skillName={"Next.js"} percentage={65} szer={inView ? "w-[65%]" : "w-[0%]"} />
                    <Skill img={"cpp.svg"} time={"4 YEARS"} skillName={"C++"} percentage={60} szer={inView ? "w-[60%]" : "w-[0%]"} />
                </div>
            </div>
        </div>
    );
}

export default SekcjaSkills;
